export default __webpack_public_path__ + "static/media/rr2.c183e7f4.jpg";